import React, { useEffect, useState } from 'react';
import { Form, Button, Col, Row, Container } from "react-bootstrap";
import { StepEightQuestionItem } from './constant';
import { convertArrayToObject, renderCheckbox, renderLabelYesNo } from 'components/HSInduction/Shared/Helpers';
import CustomSweetAlert from 'components/Shared/CustomSweetAlert';

const StepEight = ({ handleNext, handleBack, storedData }) => {
    const apiURL = process.env.REACT_APP_JOB_URL;
    const [formData, setFormData] = useState([]);
    const [errors, setErrors] = useState({});
    const [alert, setAlert] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0)
        if (storedData) {
            const data = StepEightQuestionItem.map(item => { item.answer = null; return item; });
            if (storedData.submitScreeningHearingAndBreathing) {
                const modifiledData = data.map(item => {
                    if (storedData.submitScreeningHearingAndBreathing.hasOwnProperty(item.index)) {
                        return { ...item, answer: storedData.submitScreeningHearingAndBreathing[item.index] };
                    }
                    return item;
                });
                setFormData(modifiledData);
            } else {
                setFormData(data);
            }
        } else {
            setFormData([]);
        }
    }, []);

    const validateForm = (formData) => {
        const errors = {}
        formData.forEach(item => {
            if (item.answer === null) {
                errors[item.index] = "This field is required";
            }
        });
        return errors;
    }

    const handleSubmit = async () => {
        try {
            const errors = validateForm(formData);

            if (!Object.values(errors).some(Boolean)) {
                setErrors([]);
                handleSaveData(formData);
            } else {
                setErrors(errors);
                window.scrollTo(0, 0);
            }
        } catch (e) {
            console.log(e);
        }
    }

    const handleSaveData = async (postData) => {
        setAlert(CustomSweetAlert({ type: "loading" }));
        const url = `/HSInduction/SubmitScreeningHearingAndBreathing?inductionId=${storedData?.inductionId}&employeeId=${storedData?.employeeId}&pin=${storedData?.pin}`;
        const method = `post`;
        const modifiedData = convertArrayToObject(postData);
        const response = await fetch(apiURL + url, {
            method,
            headers: [
                ["Content-Type", "application/json"],
                ["Content-Type", "text/plain"]
            ],
            body: JSON.stringify(modifiedData),
        });
        if (response.status === 200) {
            handleNext(modifiedData);
        } else {
            setAlert(CustomSweetAlert({
                type: "error", title: "Error", message: `Error: Save step 8 failed`,
                onConfirm: () => {
                    hideAlert();
                }, showCancel: false
            }));
        }
    }

    const handleChangeData = (value, indexKey) => {
        setFormData(prevItems =>
            prevItems.map(item =>
                item.index === indexKey ? { ...item, answer: value } : item
            )
        );
    }

    const renderQuestionItems = () => {
        return formData.length && formData?.map((question, index) => {
            return <Row className='mb-3' key={index}>
                {renderQuestion(question)}
            </Row>;
        })
    }

    const renderQuestion = (questionItem) => {
        return <>
            <Col lg="9" md="9" xs="9" className='text-start'>
                <h5 className="mb-0 mt-3">{questionItem.question}<span className="star">*</span></h5>
                {errors[questionItem.index] && <Form.Text className="text-danger"><span className="star">*</span> {errors[questionItem.index]} </Form.Text>}
            </Col>
            <Col lg="3" md="3" xs="3" className="mb-0 mt-3">
                {renderCheckbox(questionItem.index, handleChangeData, questionItem.answer?.toString())}
            </Col>
        </>
    }

    const hideAlert = () => setAlert(null);

    return (
        <>
            <Row>
                {alert}
                <Col sm={12} md={12}>
                    <h2>7. Screening Questionnaire - Hearing and Breathing</h2>
                    <span style={{ marginTop: '-15px' }}>Please answer the following questions by ticking Yes or No</span>
                </Col>
                <Col md={12} xs="12" className="mx-auto">
                    <Container>
                        {/* <Row className='mt-2'>
                            <Col lg="9" md="9" xs="9"></Col>
                            <Col lg="3" md="3" xs="3">
                                {renderLabelYesNo()}
                            </Col>
                        </Row> */}
                        {renderQuestionItems()}
                    </Container>
                </Col>
            </Row >
            <Row>
                <Col sm={12} className="d-flex justify-content-end mt-3">
                    <Button className="btn-lg btn-shadow btn-step" variamt="danger" onClick={handleBack} >Back</Button>
                    <Button className="btn-lg btn-shadow btn-step" variant="success" onClick={handleSubmit} >Next Step</Button>
                </Col>
            </Row>
        </>
    );
};

export default StepEight;
